import './_check.scss';
import './_check.dark-mode.scss';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';

import Dropdown from '../../Dropdown/Default';
import Checkbox from '../../Checkbox/Simple';

const TableCheckAll = ({
  values,
  title,
  transKey,
  transValue,
  onChangeCheck,
  accessMassActions,
  handleSelect,
  submenuStatuses,
  toolbarClass,
  pullRight,
  configAccess,
  tdClass,
  totals,
}) => {
  const { t } = useTranslation();

  return (
    <th className={`${values.length > 0 ? 'check-all check-all__show' : 'check-all'} ${tdClass}`}>
      <div className="check-all__container">
        <div className="check-all__box">
          <Checkbox value="checkAll" onChangeCheck={onChangeCheck} checked={values.length > 0} />
        </div>
        <div className="table__mass-act">
          <ul className="mass-act__list">
            <li>
              <span>
                <Trans i18nKey={transKey} defaults={transValue} values={{ count: values.length }} />
              </span>
            </li>
            <li>
              <Dropdown
                handleSelect={handleSelect}
                size="xsmall"
                title={t(`Table.${title}`)}
                forMassActions
                submenuStatuses={submenuStatuses}
                classForBtnDrop="fontWieghtMed"
                dropStyle="default"
                items={accessMassActions}
                toolbarClass={toolbarClass}
                pullRight={pullRight}
                configAccess={configAccess}
              />
            </li>
          </ul>
          <div>
            {totals?.length && (
              <div className="mass-act__totals">
                {totals?.map((item) => (
                  <div className="total-item">
                    <span className="name">
                      {item.label}
                      :
                    </span>
                    {' '}
                    <span className="value">{item.value}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </th>
  );
};

TableCheckAll.propTypes = {
  values: PropTypes.array,
  title: PropTypes.string,
  transKey: PropTypes.string,
  transValue: PropTypes.string,
  onChangeCheck: PropTypes.func,
  accessMassActions: PropTypes.array,
  handleSelect: PropTypes.func,
  submenuStatuses: PropTypes.array,
  toolbarClass: PropTypes.string,
  pullRight: PropTypes.bool,
  configAccess: PropTypes.object,
  tdClass: PropTypes.string,
  totals: PropTypes.array,
};

TableCheckAll.defaultProps = {
  title: 'Actions',
  values: [],
  tdClass: '',
};

export default TableCheckAll;
